"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatIOSMobile = formatIOSMobile;
exports.getMobileLinkRegistry = getMobileLinkRegistry;
exports.getMobileRegistryEntry = getMobileRegistryEntry;
exports.mobileLinkChoiceKey = void 0;
exports.saveMobileLinkInfo = saveMobileLinkInfo;

var _local = require("./local");

var mobileLinkChoiceKey = "WALLETCONNECT_DEEPLINK_CHOICE";
exports.mobileLinkChoiceKey = mobileLinkChoiceKey;

function formatIOSMobile(uri, entry) {
  var encodedUri = encodeURIComponent(uri);
  return entry.universalLink ? "".concat(entry.universalLink, "/wc?uri=").concat(encodedUri) : entry.deepLink ? "".concat(entry.deepLink).concat(entry.deepLink.endsWith(":") ? "//" : "/", "wc?uri=").concat(encodedUri) : "";
}

function saveMobileLinkInfo(data) {
  var focusUri = data.href.split("?")[0];
  (0, _local.setLocal)(mobileLinkChoiceKey, Object.assign(Object.assign({}, data), {
    href: focusUri
  }));
}

function getMobileRegistryEntry(registry, name) {
  return registry.filter(function (entry) {
    return entry.name.toLowerCase().includes(name.toLowerCase());
  })[0];
}

function getMobileLinkRegistry(registry, whitelist) {
  var links = registry;

  if (whitelist) {
    links = whitelist.map(function (name) {
      return getMobileRegistryEntry(registry, name);
    }).filter(Boolean);
  }

  return links;
}